module.exports = __webpack_public_path__ + "img/studiesbg@2x.ffc6cb0f.png";